import { cn } from '@/lib/cn'

/** Avatar de iniciales para usuarios cliente (C1). */
export function AvatarIniciales({
  nombre,
  className,
}: {
  nombre: string
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-borde text-sm font-semibold text-tinta',
        className,
      )}
      aria-label={nombre}
    >
      {iniciales(nombre)}
    </span>
  )
}

export function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean)
  const primera = partes[0]?.[0] ?? ''
  const segunda =
    partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? '') : (partes[0]?.[1] ?? '')
  return (primera + segunda).toUpperCase()
}
